import {
  GET_OFFERS,
  GET_OFFER,
  ADD_OFFER,
  UPDATE_OFFER,
  DELETE_OFFER,
  OFFER_ERROR,
  OFFER_LOADING,
} from "../actions/types";

const initialState = {
  list: [],
  current: null,
  loading: false,
  error: null,
};

export default function offerReducer(state = initialState, action) {
  switch (action.type) {
    case OFFER_LOADING:
      return { ...state, loading: true };
    case GET_OFFERS:
      return { ...state, list: action.payload, loading: false };
    case GET_OFFER:
      return { ...state, current: action.payload, loading: false };
    case ADD_OFFER:
      return { ...state, loading: false };
    case UPDATE_OFFER:
      return { ...state, loading: false };
    case DELETE_OFFER:
      return {
        ...state,
        list: state.list.filter((o) => o._id !== action.payload),
        loading: false,
      };
    case OFFER_ERROR:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
}
